import axios from "axios";

export default {

  createRequest() {
    let instance = axios.create({baseURL:  process.env.VUE_APP_SF_SERVICE_URL+'/api/v1/auth/'});
    instance.interceptors.request.use(
      (config) => {
        let token = localStorage.getItem('auth__access_token');
        if (token) {
          config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
      }
    );
    return instance;
  },

  checkLogin() {
    return this.createRequest().get('/');
  },

  login(username, password) {
    return this.createRequest().post('login', {username, password});
  },

  confirm(username, session, code) {
    return this.createRequest().post('confirm', {username, code});
  },

  resendConfirm(username) {
    return this.createRequest().post('resend-confirmation', {username});
  },

  resetPassword(username, password, session) {
    return this.createRequest().post('reset-password', {username, password, session});
  },

  requestReset(username) {
    return this.createRequest().post('request-reset', {username});
  },

  confirmReset(username, code, password) {
    return this.createRequest().post('confirm-reset', {username, code, password});
  },

  refresh(token) {
    return this.createRequest().post('refresh', {token});
  },

  validate() {
    return this.createRequest().get('validate');
  },

};